const ArticleHighlights = ({
  highlights,
  variant = "default",
  title = "Puntos clave para recordar",
}) => {
  const isEmpresas = variant === "empresas";
  return (
    <aside
      className={`mt-16 border rounded-3xl p-8 ${
        isEmpresas
          ? "bg-[#e9e8f4] border-purple-100"
          : "bg-[#e8f2f4] border-blue-100"
      }`}
    >
      <h3 className="text-2xl font-semibold text-[#123070] mb-4">{title}</h3>
      <ul className="space-y-3 text-gray-700 leading-relaxed text-lg">
        {highlights.map((item, index) => (
          <li key={index} className="flex items-start gap-3">
            <span
              className={`mt-1 inline-flex h-2 w-2 rounded-full ${
                isEmpresas ? "bg-purple-600" : "bg-blue-600"
              }`}
            />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default ArticleHighlights;
